import axios from '@/utils/request'
var Qs = require('qs')

export default {
  // 2020-09-15
  search(params) {
    return axios.get('/bargains?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-05-15
  webSearchNoOrders(params) {
    return axios.get('/bargains/web-search-no-orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2022-03-28
  applyTrackingWebSearchNoOrders(params) {
    return axios.get('/bargains/apply-tracking-web-search-no-orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2023-02-20
  sameCustomerSearchNoOrders(params) {
    return axios.get('/bargains/same-customer-search-no-orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2023-02-20
  sameCustomerCount() {
    return axios.get('/bargains/same-customer-count');
  },
  // 2022-03-28
  batchGetTracking(params) {
    return axios.put('/bargains/batch-get-tracking', params);
  },
  // 2022-8-20
  cancelTracking(id) {
    return axios.put('/bargains/' + id + '/cancel-tracking');
  },
  // 2022-09-21
  batchUploadTracking(params) {
    return axios.put('/bargains/batch-upload-tracking', params)
  },
  // 2020-11-09
  pendingDeliverSearch(params) {
    return axios.get('/bargains/pending-deliver-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-06-17
  pendingDeliverSearchNoOrders(params) {
    return axios.get('/bargains/pending-deliver-search-no-orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-08-18
  debtSearchNoOrdersReport(params) {
    return axios.get('/bargains/debt-search-no-orders-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-08-18
  debtSearchNoOrdersReportExportExcel(params) {
    return axios.get('/bargains/debt-search-no-orders-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },

  // 2020-09-15
  findBySerialNo(params) {
    return axios.post('/bargains/find-by-serial-no', params);
  },
  // 2020-09-21
  groupsInsertBatch(params) {
    return axios.put('/bargains/groups/insert-batch', params);
  },
  // 2020-09-21
  updateGroup(params) {
    return axios.put('/bargains/update-group', params);
  },
  // 2020-09-21
  exportExcel(params) {
    return axios.get('/bargains/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-11-16
  pendingDeliverSearchExportExcel(params) {
    return axios.get('/bargains/pending-deliver-search/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-09-21
  mergeBargain(params) {
    return axios.post('/bargains/merge', params);
  },
  // 2020-09-22
  create(params) {
    return axios.post('/bargains', params);
  },
  // 2020-09-23
  findByUuid(params) {
    return axios.get('/bargains/find-by-uuid', params)
  },
  // 2020-10-19
  update(id, params) {
    return axios.put('/bargains/' + id, params)
  },
  //2020-10-20
  updateCustomerInfo(params) {
    return axios.put('/bargains/update-customer-info', params);
  },
  //2020-10-20
  updateHurry(id) {
    return axios.put('/bargains/' + id + '/update-hurry');
  },
  //2020-10-20
  updateHandOverAt(id, params) {
    return axios.put('/bargains/' + id + '/update-hand-over-at', params);
  },
  //2020-10-20
  delete(id) {
    return axios.delete('/bargains/' + id)
  },
  //2021-12-10
  batchDelete(params) {
    return axios.put('/bargains/batch-delete', params)
  },

  // 2020-10-15
  updataOwner(params) {
    return axios.put('/bargains/update-owner', params);
  },
  // 2021-05-13
  batchUpdateOwner(params) {
    return axios.put('/bargains/batch-update-owner', params);
  },
  // 2020-10-30
  copy(id, params) {
    return axios.put('/bargains/' + id + '/copy', params);
  },
  // 2020-11-28
  deliveryCount() {
    return axios.get('/bargains/delivery-count');
  },

  // 2020-11-30
  findWithOrdersByIds(params) {
    return axios.post('/bargains/find-with-orders-by-ids', params);
  },
  // 2021-05-17
  findWithOrdersByIdsForList(params) {
    return axios.post('/bargains/find-with-orders-by-ids-for-list', params);
  },
  // 2021-06-20
  findWithOrdersByIdsForDeliverList(params) {
    return axios.post('/bargains/find-with-orders-by-ids-for-deliver-list', params);
  },

  // 2020-12-03
  batchFinanceVerifyAgree(params) {
    return axios.put('/bargains/batch-finance-verify-agree', params);
  },
  // 2020-12-03
  financeVerifyAgree(id) {
    return axios.put('/bargains/' + id + '/finance-verify-agree');
  },
  // 2020-12-03
  financeVerifyReject(id, params) {
    return axios.put('/bargains/' + id + '/finance-verify-reject', params);
  },
  // 2020-12-03
  financeVerifyCancel(id) {
    return axios.put('/bargains/' + id + '/finance-verify-cancel');
  },
  // 2020-12-07
  batchDebtDeliverVerifyAgree(params) {
    return axios.put('/bargains/batch—debt-deliver-verify-agree', params);
  },

  // 2020-12-10
  userSalesCount() {
    return axios.get('/bargains/user-sales-count');
  },
  // 2020-12-10
  shopSalesCount() {
    return axios.get('/bargains/shop-sales-count');
  },
  // 2020-12-10
  wholesaleCustomerCount() {
    return axios.get('/bargains/wholesale-customer-count ');
  },
  // 2020-12-10
  sevenDayCount() {
    return axios.get('/bargains/seven-day-count');
  },

  // 2020-12-19
  financeVerifyRejectCount() {
    return axios.get('/bargains/finance-verify-reject-count');
  },
  // 2020-12-30
  pendingConfrimCount() {
    return axios.get('/bargains/pending-confrim-count');
  },

  // 2021-01-23
  pauseDelivery(id) {
    return axios.put('/bargains/' + id + '/pause-delivery');
  },
  // 2021-01-23
  pauseDeliveryCount() {
    return axios.get('/bargains/pause-delivery-count');
  },
  // 2021-01-30
  immediateDelivery(id, params) {
    return axios.put('/bargains/' + id + '/immediate-delivery', params);
  },

  // 2021-03-09
  wholesaleCustomerRankingReport(params) {
    return axios.get('/bargains/wholesale-customer-ranking-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-03-09
  wholesaleCustomerRankingReportExportExcel(params) {
    return axios.get('/bargains/wholesale-customer-ranking-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-03-09
  costProfitReport(params) {
    return axios.get('/bargains/cost-profit-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-03-09
  costProfitReportExportExcel(params) {
    return axios.get('/bargains/cost-profit-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-03-09
  costProfitReportCount(params) {
    return axios.get('/bargains/cost-profit-report-count?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-02-01
  findByIds(params) {
    return axios.put('/bargains/find-by-ids', params);
  },
  // 2021-05-12
  unFinanceVerifyCount() {
    return axios.get('/bargains/un-finance-verify-count');
  },

  // 2021-10-26
  follows(id) {
    return axios.get('/bargains/' + id + '/follows')
  },
  // 2021-10-26
  createFollow(id, params) {
    return axios.post('/bargains/' + id + '/follows', params)
  },
  // 2022-02-16
  userSalesCountCustom(params) {
    return axios.get('/bargains/user-sales-count-custom', params)
  },
  // 2023-04-23
  findHsInfoByIds(params) {
    return axios.put('/bargains/find-hs-info-by-ids', params)
  },
  // 2023-05-06
  applyTrackingCircleWeight(params) {
    return axios.put('/bargains/apply-tracking-circle-weight', params)
  },
  // 2023-08-15
  updateOwnerCustomer(id, params) {
    return axios.put('/bargains/' + id + '/update-owner-customer', params)
  },
  // 2020-10-15
  findById(id) {
    return axios.get('/bargains/' + id);
  },
}